import { graphql } from "react-relay";
import "./EventPeople.gql";

export const eventPeopleRendererQuery = graphql`
  query EventPeopleRendererQuery($orgRelayId: ID!, $externalEventId: String!) {
    org: node(id: $orgRelayId) {
      ... on Org {
        ...EventPeople_org @arguments(externalEventId: $externalEventId)
      }
    }
  }
`;
